import React, { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { Button, Col, Form, Image, Row, Table } from 'react-bootstrap'
import { BsArrowClockwise } from 'react-icons/bs'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import NavRoleOrg from '../../../components/nav-role-org'
import { useSelector } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import InputSearchCustom from '../../../components/custom/InputSearchCustom'
import excelImg from '../../../images/xlsFile.svg'
import styled from 'styled-components'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import CustomDatePicker from '../../../components/custom/CustomDatePicker'
import {
  excelReportGustoAmountAPI,
  listReportGustoAmountAPI
} from '../../../services/report/gusto'
import { fnDateEn } from '../../../helper/fnDateEn'
import { ExportExcelLip } from '../../../helper/exportExcelLip'
import Error_false from '../../../components/error/error-false'

export default function GustoReportPage() {
  const roleId = useSelector((state) => state.roleReducer.role)
  const [isLoading, setIsLoading] = useState(false)
  const [totalRow, setTotalRow] = useState(0)
  const [dataTable, setDataTable] = useState([])
  const totalLimits = 20
  const [bodyFilter, setBodyFilter] = useState()
  const [page, setPage] = useState(1)
  const [endDate, setEndDate] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const to_day = new Date()

  useEffect(() => {
    const body = {
      page: 1,
      orgId: roleId,
      startDate: `${fnDateEn(to_day).format('YYYY-MM-DD')}`,
      endDate: `${fnDateEn(to_day).format('YYYY-MM-DD')}`
    }
    setEndDate(new Date(body.endDate))
    setStartDate(new Date(body.startDate))
    setPage(1)
    if (roleId) fnGetData(body)
  }, [roleId])

  const fnGetData = async (body) => {
    setIsLoading(true)
    setBodyFilter(body)
    const resp = await listReportGustoAmountAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setDataTable(resp.result)
      setTotalRow(resp.totalRows)
    } else {
      setTotalRow(0)
      setDataTable([])
    }
  }
  const [isExcel, setIsExcel] = useState(false)
  const fnExportExcel = async () => {
    const body = {
      orgId: bodyFilter.orgId,
      startDate: bodyFilter.startDate,
      endDate: bodyFilter.endDate,
      searchs: bodyFilter.searchs
    }
    setIsExcel(true)
    setIsLoading(true)
    const resp = await excelReportGustoAmountAPI(body)
    setIsExcel(false)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      const dataExcel = resp.result.map((d, i) => {
        return {
          num: i + 1,
          org: d.org,
          code: d.code,
          name: `${d.titleTh ?? ''} ${d.nameTh} ${d.surnameTh}`,
          division: d.division,
          department: d.department,
          positionTh: d.positionTh,
          amount: d.amount
        }
      })
      const header = [
        '#',
        'ORG',
        'Code',
        'Name',
        'Group',
        'Department',
        'Position',
        'Use Amount'
      ]
      ExportExcelLip({
        header,
        dataExcel,
        fileName: `gusto-${fnDateEn().format('YYYYMMDDHHmmss')}`
      })
    } else {
      Error_false(resp)
    }
  }

  const { control, setValue, handleSubmit } = useForm({})
  const onClearSearch = () => {
    const body = {
      ...bodyFilter,
      page: 1,
      searchs: ''
    }
    setPage(1)
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      ...bodyFilter,
      page: 1,
      orgId: roleId,
      searchs: d.search
    }
    setPage(1)
    fnGetData(body)
  }
  return (
    <div>
      <NavTitle>
        <TextNavTitle>Gusto</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />

      <CardCustom className="d-flex justify-content-between ">
        <div>
          <div className="p-3">
            <Row className="g-3">
              <Col md={2} className="my-auto small">
                <label
                  className="my-auto fw-bold me-3"
                  style={{
                    fontSize: '14px'
                  }}
                >
                  Total: {totalRow?.toLocaleString()}
                </label>
              </Col>

              <Col
                md={10}
                className="d-flex align-self-end justify-content-end"
              >
                <BoxFilter className="justify-content-end">
                  <div className="btn-date-start">
                    <CustomDatePicker
                      placeholder="Start Date"
                      isClearable={false}
                      value={startDate}
                      maxDate={endDate}
                      onChange={(d) => {
                        if (d) {
                          setStartDate(d)
                          if (!endDate) {
                            setEndDate(d)
                          }

                          const body = {
                            ...bodyFilter,
                            page: 1,
                            startDate: `${fnDateEn(d).format('YYYY-MM-DD')}`
                          }

                          fnGetData(body)
                        } else {
                          setStartDate(null)
                        }
                      }}
                      showYearDropdown
                      showMonthDropdown
                    />
                  </div>
                  <div className="btn-date-end ">
                    <CustomDatePicker
                      placeholder="End Date"
                      isClearable={false}
                      value={endDate}
                      minDate={startDate}
                      onChange={(d) => {
                        if (d) {
                          const body = {
                            ...bodyFilter,
                            page: 1,
                            endDate: `${fnDateEn(d).format('YYYY-MM-DD')}`
                          }

                          fnGetData(body)
                          setEndDate(d)
                        } else {
                          setEndDate(null)
                        }
                      }}
                      showYearDropdown
                      showMonthDropdown
                    />
                  </div>
                  <Form
                    className="from-search"
                    onSubmit={handleSubmit(onSearch)}
                  >
                    <Controller
                      name={'search'}
                      control={control}
                      render={({ field: { onChange, value = '' } }) => (
                        <InputSearchCustom
                          value={value}
                          onChange={(d) => {
                            onChange(d)

                            if (!d) {
                              onClearSearch()
                            }
                          }}
                          placeholder="Search"
                        />
                      )}
                    />
                  </Form>
                  <Button
                    className="btn-reflesh"
                    variant="light"
                    onClick={() => {
                      const body = {
                        page: 1,
                        orgId: roleId,
                        startDate: `${fnDateEn(to_day).format('YYYY-MM-DD')}`,
                        endDate: `${fnDateEn(to_day).format('YYYY-MM-DD')}`
                      }
                      setValue('search', '')
                      setPage(1)
                      fnGetData(body)
                    }}
                  >
                    <BsArrowClockwise />
                  </Button>
                  <Button
                    disabled={totalRow === 0 || isExcel}
                    className="btn-excel"
                    onClick={fnExportExcel}
                  >
                    <Image src={excelImg} style={{ width: '15px' }} />
                  </Button>
                </BoxFilter>
              </Col>
            </Row>
          </div>

          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className="fw-light font-title-table">
                <th className="fw-normal">#</th>
                <th className="fw-normal">ORG</th>
                <th className="fw-normal">Code</th>
                <th className="fw-normal">Name</th>
                <th className="fw-normal">Group </th>
                <th className="fw-normal">Department</th>
                <th className="fw-normal">Position</th>
                <th className="fw-normal">Use Amount</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <>
                  <TableSkeletonBody colSpan={8} rowSpan={10} />
                </>
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr className="fw-light font-small-2 " key={i}>
                    <td> {page * totalLimits - totalLimits + i + 1}</td>
                    <td className="">
                      <div>{d.org}</div>
                    </td>
                    <td className="">
                      <div>{d.code}</div>
                    </td>
                    <td className="">
                      <div>
                        {d.titleTh}
                        {d.nameTh} {d.surnameTh}
                      </div>
                      <div>
                        {d.titleEn} {d.nameEn} {d.surnameEn}
                      </div>
                    </td>
                    <td className="">
                      <div>{d.division}</div>
                    </td>
                    <td className="">
                      <div>{d.department}</div>
                    </td>
                    <td className="">
                      <div>{d.positionTh}</div>
                    </td>
                    <td className="">
                      <div>{d.amount?.toLocaleString()}</div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="table-body">
                  <td colSpan={8} className="text-center">
                    -No Data-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="p-3">
          <PaginationControl
            page={page}
            total={totalRow}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)
              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>
    </div>
  )
}

const BoxFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .from-search {
    flex: 0 0 250px;
  }
  .btn-reflesh {
    flex: 0 0 30px;
  }
  .btn-excel {
    flex: 0 0 30px;
  }
  .btn-status {
    flex: 0 0 150px;
  }
  .btn-date-start {
    flex: 0 0 150px;
  }
  .btn-date-end {
    flex: 0 0 150px;
  }
`
